/* eslint-disable max-lines-per-function */
export const isImage = file => file && file.type.startsWith("image/");

export const readImageFile = file => {
  if (!isImage(file)) {
    return Promise.reject(new Error("Not an image"));
  }

  const localReader = new FileReader();

  const promise = new Promise((resolve, reject) => {
    localReader.onload = result =>
      resolve({
        type: file.type,
        size: file.size,
        dataUrl: result.target.result
      });
    localReader.onerror = error => reject(error);
  });

  localReader.readAsDataURL(file);

  return promise;
};

export const validateFile = (file, { extension, accept }) => {
  // Windows machines might miss the MIME type, so checking by extension
  if (!file.type && file.name) {
    // eslint-disable-next-line no-useless-escape
    const regex = new RegExp(`\.${extension}$`, "i");
    return regex.test(file.name);
  }
  return accept.includes(file.type);
};

export const getFileFromUrl = async (url, name, defaultType = "image/jpeg") => {
  const response = await fetch(url);
  const data = await response.blob();

  const type = data.type || defaultType;
  const extension = type?.split("/")?.pop();
  const fullName = extension ? `${name}.${extension}` : name;

  return new File([data], fullName, { type });
};
